(() => {
  if (window.FumoProductRailsLoaded) return;
  window.FumoProductRailsLoaded = true;
  const historyKey = 'recently_viewed_products';
  const fetched = new Map();
  const readHistory = () => {
    try { const items = JSON.parse(localStorage.getItem(historyKey) || '[]'); return Array.isArray(items) ? [...new Set(items.filter(h => typeof h === 'string' && h.length < 255))] : []; }
    catch (_) { return []; }
  };
  const getJSON = async url => {
    if (!fetched.has(url)) fetched.set(url, fetch(url).then(r => { if (!r.ok) throw new Error(`Product rail: ${r.status}`); return r.json(); }));
    return fetched.get(url);
  };
  const node = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text != null) el.textContent = text; return el; };
  const gameOf = p => ({'ポケモンカード':'po','デュエル・マスターズ':'dm','Xross Stars':'xs'}[p.cardTitle] || p.handle.split('-')[0]);
  const spinner = '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>';
  // Opens the rail's shared quick-add sheet for this product (state and quantity are chosen there, as in the collection cards).
  const addButton = (p, root, modalId) => {
    const button = node('button', 'quick-add__submit button button--full-width button--secondary fumo-rail__add', 'カートに追加');
    button.type = 'button';
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-label', `${p.title}をカートに追加`);
    button.dataset.productUrl = `${root}products/${encodeURIComponent(p.handle)}`;
    const spin = node('div', 'loading__spinner hidden');
    spin.innerHTML = spinner;
    button.append(spin);
    button.addEventListener('click', () => document.getElementById(modalId)?.show(button));
    return button;
  };
  const card = (p, recent, pack, root, i, soldOutColor, modalId) => {
    const li = node('li', 'fumo-rail__item' + (!p.available ? ' fumo-rail__item--sold-out' : ''));
    li.dataset.handle = p.handle;
    const a = node('a', 'fumo-rail__card');
    a.href = `${root}${!recent && pack && p.railInPack ? `collections/${encodeURIComponent(pack)}/` : ''}products/${encodeURIComponent(p.handle)}`
      + (recent ? `?ref=recent&pos=${i + 1}` : (p.linkQuery || `?ref=related&pos=${i + 1}`));
    const frame = node('div', 'fumo-rail__image-frame');
    if (p.image) {
      const img = node('img', 'fumo-rail__image');
      img.alt = p.cardName || p.title; img.width = 170; img.height = 237;
      // The first cards start loading as soon as the rail has its data, at the size the rail shows (one collection grid column).
      img.loading = i < 4 ? 'eager' : 'lazy';
      if (i < 4) img.fetchPriority = 'low';
      if (/[?&]width=\d+/.test(p.image)) {
        img.srcset = [200, 300, 400].map((w) => `${p.image.replace(/([?&])width=\d+/, `$1width=${w}`)} ${w}w`).join(', ');
        img.sizes = '(min-width: 990px) 177px, (min-width: 750px) 218px, 34vw';
      }
      const ready = () => frame.classList.add('fumo-rail__image-frame--ready');
      img.addEventListener('load', ready, {once:true});
      img.addEventListener('error', () => {img.replaceWith(node('span', 'fumo-rail__image-fallback', '画像準備中'));}, {once:true});
      frame.append(img); img.src = p.image;
      if (img.complete && img.naturalWidth > 0) ready();
    } else frame.append(node('span', 'fumo-rail__image-fallback', '画像準備中'));
    if (p.badgeHtml != null) {
      const badge = node('div', 'fumo-rail__badge');
      badge.innerHTML = p.badgeHtml;
      if (badge.childElementCount) frame.append(badge);
    } else if (!p.available) {
      frame.append(node('span', `fumo-rail__sold-out badge badge--bottom-left ${soldOutColor}`, '在庫なし'));
    }
    if (p.stampHtml) frame.insertAdjacentHTML('beforeend', p.stampHtml);
    a.append(frame);
    // Same name markup as the collection cards: the printed number on its own line, no number for sets.
    const name = node('p', 'fumo-rail__name');
    if (p.titleHtml != null) name.innerHTML = p.titleHtml; else name.textContent = p.title;
    a.append(name);
    const price = node('div', 'fumo-rail__price');
    if (p.priceHtml != null) price.innerHTML = p.priceHtml;
    else if (!p.available) price.append(node('span', 'price-item--soldout-text', '在庫なし'));
    else { price.append(document.createTextNode(`¥${(p.price / 100).toLocaleString('ja-JP')}${p.priceVaries ? '〜' : ''}`), node('small', '', '(税込)')); }
    a.append(price); li.append(a);
    if (p.available && modalId) li.append(addButton(p, root, modalId));
    else if (!p.available) {
      const soldOut = node('button', 'quick-add__submit button button--full-width button--secondary fumo-rail__add');
      soldOut.type = 'button'; soldOut.disabled = true;
      soldOut.append(node('span', '', '在庫なし'));
      li.append(soldOut);
    }
    return li;
  };
  const loading = section => {
    const list = section.querySelector('[data-rail-list]');
    section.classList.add('fumo-rail--loading');
    section.setAttribute('aria-busy', 'true');
    section.hidden = false;
    const clear = section.querySelector('[data-rail-clear]');
    if (clear) clear.disabled = true;
    if (list.children.length) return;
    list.replaceChildren(...Array.from({length:6}, () => {
      const li = node('li', 'fumo-rail__item fumo-rail__skeleton');
      li.setAttribute('aria-hidden', 'true');
      const body = node('div', 'fumo-rail__card');
      body.append(node('div', 'fumo-rail__image'), node('div', 'fumo-rail__skeleton-name'), node('div', 'fumo-rail__skeleton-price'));
      li.append(body); return li;
    }));
  };
  const mount = (section, products, recent) => {
    const list = section.querySelector('[data-rail-list]');
    section.classList.remove('fumo-rail--loading');
    section.setAttribute('aria-busy', 'false');
    const clear = section.querySelector('[data-rail-clear]');
    if (clear) clear.disabled = false;
    if (products.length < (recent ? 2 : 1)) { section.hidden = true; return; }
    const root = section.dataset.root || '/';
    list.replaceChildren(...products.map((p, i) => card(p, recent, section.dataset.pack, root, i, list.dataset.soldOutColor, list.dataset.quickAdd)));
    section.hidden = false;
    const arrows = section.querySelector('[data-rail-arrows]'), prev = section.querySelector('[data-rail-prev]'), next = section.querySelector('[data-rail-next]');
    const unit = () => list.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(list).gap);
    const update = () => {
      if (matchMedia('(min-width:750px)').matches) {
        const available = section.clientWidth - parseFloat(getComputedStyle(section).paddingLeft) - parseFloat(getComputedStyle(section).paddingRight);
        const gap = parseFloat(getComputedStyle(list).gap), count = Math.max(1, Math.min(6, Math.floor((available + gap) / unit())));
        list.style.setProperty('--rail-width', `${count * unit() - gap}px`);
      } else list.style.removeProperty('--rail-width');
      const overflow = list.scrollWidth - list.clientWidth;
      arrows.hidden = overflow <= 2;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= overflow - 2;
    };
    const move = direction => {
      const count = Math.max(1, Math.floor((list.clientWidth + parseFloat(getComputedStyle(list).gap)) / unit() + 0.01));
      list.scrollBy({left:direction * unit() * count,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    };
    prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1)); list.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(section); update();
  };
  const recent = async section => {
    const handles = readHistory().filter(h => h !== section.dataset.currentHandle).slice(0, 10);
    if (handles.length < 2) { section.hidden = true; return; }
    loading(section);
    const root = section.dataset.root || '/';
    const products = await Promise.all(handles.map(h => getJSON(`${root}products/${encodeURIComponent(h)}?view=rail`).catch(() => null)));
    if (!section.isConnected || section.dataset.cleared === 'true') return;
    mount(section, products.filter(Boolean), true);
    section.querySelector('[data-rail-clear]').addEventListener('click', () => {
      try { localStorage.removeItem(historyKey); } catch (_) {}
      document.querySelectorAll('[data-product-rail="recent"]').forEach(s => {s.dataset.cleared = 'true';s.hidden = true;s.querySelector('[data-rail-list]').replaceChildren();});
    });
  };
  const related = async section => {
    loading(section);
    const current = JSON.parse(section.dataset.current), root = section.dataset.root || '/', pack = section.dataset.pack;
    const baseName = (current.cardName || '').split(/[／/]/u)[0].replace(/(?:VMAX|VSTAR|GX|EX|ex|V)$/u, '').trim();
    const pool = async () => {
      if (!pack) return [];
      const url = `${root}collections/${encodeURIComponent(pack)}?view=rail&sort_by=price-descending&filter.v.availability=1`;
      const first = await getJSON(url);
      const pages = await Promise.all(Array.from({length:Math.min(Math.max(0,first.pages-1),9)},(_,i) => getJSON(`${url}&page=${i+2}`).catch(() => ({products:[]}))));
      return first.products.concat(...pages.map(p => p.products));
    };
    const recP = getJSON(`${root}recommendations/products.json?product_id=${current.id}&limit=10&intent=related`).then(x=>x.products || []).catch(()=>[]);
    // Fetch the recommended products' details alongside the pack and search instead of after them (one round trip less).
    const recDetailsP = recP.then(list => Promise.all(list.map(p => getJSON(`${root}products/${encodeURIComponent(p.handle)}?view=rail`).catch(()=>null))));
    const [samePack, alternatives, rec, orders, recFetched] = await Promise.all([
      pool().catch(() => []),
      baseName.length > 1 ? getJSON(`${root}search?type=product&q=${encodeURIComponent('"'+baseName+'"')}&view=rail&options[unavailable_products]=hide`).then(x=>x.products).catch(()=>[]) : [],
      recP,
      getJSON(section.dataset.rarities).catch(()=>({})),
      recDetailsP
    ]);
    const game = gameOf(current), order = orders[game] || [], ranks = new Map(rec.map((p,i)=>[p.id,i]));
    // 推薦 API の url に付く pr_rec_id などを引き継がないと、Shopify の関連商品クリック集計に載らない。
    const recQuery = new Map(rec.map(p => [p.id, (p.url || '').includes('?') ? p.url.slice(p.url.indexOf('?')) : '']));
    // Search & Discovery・推薦に入った商品は、セット・デッキ・共通サプライもカードのページに出す。
    const eligible = p => p && p.id !== current.id && p.available && (ranks.has(p.id)
      ? (gameOf(p) === game || p.cardTitle === 'common')
      : gameOf(p) === game && (!current.isCard || p.isCard));
    const sameCharacter = p => baseName && (p.cardName || '').includes(baseName);
    const poolIDs = new Set(samePack.map(p=>p.id));
    // おすすめ上位の商品も詳細データを取得し、在庫とタイトルを検証する。
    const known = new Map([...samePack,...alternatives].map(p=>[p.id,p]));
    const recDetails = rec.map((p, i) => known.get(p.id) || recFetched[i]);
    const all = [...new Map([...samePack,...alternatives.filter(sameCharacter),...recDetails].filter(eligible).map(p=>[p.id,p])).values()];
    const rarityRank = p => {const code=game==='xs' ? (p.rarity || '').replace(/^(LR|SR|PP)P+$/u,'$1') : p.rarity;const rank=order.indexOf(code);return rank<0 ? order.length : rank;};
    const highRarity = p => {const rank=rarityRank(p),common=order.indexOf(game==='po'?'R':game==='dm'?'R':'R');return rank<(common<0?3:common);};
    const group = p => poolIDs.has(p.id) && p.price>=10000 && (highRarity(p)||ranks.has(p.id)) ? 0 : sameCharacter(p) ? 1 : poolIDs.has(p.id) ? 2 : 3;
    all.forEach(p => {p.railInPack = poolIDs.has(p.id); p.linkQuery = recQuery.get(p.id) || '';});
    // Search & Discovery の順序を最優先し、残りを同パック・同名商品で補完する。
    all.sort((a,b)=>{
      if (ranks.has(a.id) || ranks.has(b.id)) return (ranks.get(a.id)??Infinity)-(ranks.get(b.id)??Infinity);
      return group(a)-group(b)||(a.price<10000)-(b.price<10000)||rarityRank(a)-rarityRank(b)||b.price-a.price||a.handle.localeCompare(b.handle);
    });
    // 同じ名前のカードが並びすぎないよう、補完で足すのは指定分と合わせて2件まで（2026-10-17）
    let sameCount = 0;
    const shown = all.filter(p => !sameCharacter(p) || ranks.has(p.id) ? (sameCharacter(p) && sameCount++, true) : sameCount++ < 2);
    mount(section, shown.slice(0,Math.min(12,Math.max(8,Number(section.dataset.maxItems)||12))), false);
  };
  const init = () => document.querySelectorAll('[data-product-rail]').forEach(s => {
    if (s.dataset.railInitialized) return;
    s.dataset.railInitialized = 'true';
    (s.dataset.productRail === 'recent' ? recent(s) : related(s)).catch(() => {s.hidden=true;s.setAttribute('aria-busy','false');s.classList.remove('fumo-rail--loading');});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
